import React from 'react';
import { Flex,IconButton, Text } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { useAppSelector } from 'Hooks';
import { useLocation } from 'react-router-dom';
import { AppRoutes } from 'Routes/AppRoutes';
import { useIsNewSurvey, getSurveyBrandName } from 'Utils/surveyUtils';
import { useSurveyExit } from 'Utils/surveyNavigationUtils';

export const HeaderSection = () => {
	const location = useLocation();
	const canClose = location.pathname !==  AppRoutes.dynamicLinkProduct;
	const {
		activeSurvey: { survey },
		hasStartedSurvey,
	} = useAppSelector((state) => state.survey);


	const headings = {
		surveyTitle: survey?.title,
		brandName: getSurveyBrandName(survey)
	};

	const isNewSurvey = useIsNewSurvey();
	// For header styling: show intro style only if survey is new AND user hasn't clicked start
	const isOnIntroScreen = isNewSurvey && !hasStartedSurvey;

	const handleSurveyExit = useSurveyExit();
	const handleCloseSurvey = () => handleSurveyExit();
	
	return (
		<Flex
			direction={['row-reverse', 'row']}
			px={['4', '10']}
			color="white"
			bg={isOnIntroScreen ? '#ECEFF2' : '#264653'}
			h={['60px','118px']}
			alignItems="center"
			justifyContent="space-between"
			position="fixed"
			top="0"
			left="0"
			right="0"
			width="100%"
		>
			<Flex 
				direction={['column', 'column']}
				alignItems={['flex-end','flex-start']}
			>
				{!isOnIntroScreen && (
					<>
						<Text 
							fontSize={['10px','25px']}
							fontWeight={['400', '600']}
							textAlign={'right'}
						>
							{headings.surveyTitle}
						</Text>
						<Text fontSize={['10px','14px']}>by {headings.brandName}</Text>
					</> 
				)}
			</Flex>
			{canClose && <IconButton
				color={isOnIntroScreen ? '#899AA2' : 'white'}
				aria-label="close survey"
				bg={['#5860681A','none']}
				w={'20px'} h={'20px'}
				borderRadius={['50%', 0]}
				ml={['-2', '0']}
				icon={<CloseIcon boxSize={['8px', '18px']} color={[ isOnIntroScreen ? 'loopGrey.500' : 'white', isOnIntroScreen ? '#26465380' : 'white']}  />}
				onClick={handleCloseSurvey}
			/>}
		</Flex>
	);
};
